import axiosInstance from "../config/axios";
import { Paging, PagingResponse } from "../types/paging";

export interface WithDiscordUsername {
  discordUsername: string;
  telegramUsername?: string;
}

export interface WithTelegramUsername {
  telegramUsername: string;
  discordUsername?: string;
}

export interface RequestOwnershipData {
  description?: string;
  takeoverClaim: string;
  website: string;
  telegram?: string;
  twitter?: string;
  discord?: string;
  docs?: string;
  contact: WithDiscordUsername | WithTelegramUsername;
}

export interface OwnershipRequest {
  _id: string;
  chainId: number;
  token: string;
  status: "pending" | "approved" | "rejected";
  walletAddress: string;
  createdAt: number;
  data: RequestOwnershipData;
  processedAt?: number;
  updatedAt: number;
}

export interface GetOwnershipRequestsResponse
  extends PagingResponse<OwnershipRequest> {}

export interface GetOwnershipRequestsParams extends Paging {
  status?: "pending" | "approved" | "rejected";
}

export const ownershipService = {
  getOwnershipRequests: async (
    params: GetOwnershipRequestsParams
  ): Promise<GetOwnershipRequestsResponse> => {
    const response = await axiosInstance.get<GetOwnershipRequestsResponse>(
      "/ownership/list",
      {
        params,
      }
    );
    return response.data;
  },

  approveOwnershipRequest: async (id: string): Promise<void> => {
    const response = await axiosInstance.post(`/ownership/approve/${id}`);
    return response.data;
  },

  rejectOwnershipRequest: async (id: string): Promise<void> => {
    const response = await axiosInstance.post(`/ownership/reject/${id}`);
    return response.data;
  },
};
